export function checkRateLimit(
  key: string,
  limit: number,
  windowMs: number,
): boolean {
  if (typeof window === "undefined") return true;

  try {
    const now = Date.now();
    const storageKey = `rate_limit_${key}`;
    const stored = localStorage.getItem(storageKey);
    let requests: number[] = [];

    if (stored) {
      requests = JSON.parse(stored);
    }

    // Filter out requests older than the window
    requests = requests.filter((time) => now - time < windowMs);

    if (requests.length >= limit) {
      return false; // Rate limited
    }

    requests.push(now);
    localStorage.setItem(storageKey, JSON.stringify(requests));
    return true;
  } catch {
    // Fallback if localStorage is unavailable (e.g., privacy modes)
    return true;
  }
}
